import React, {useState} from 'react';
import './MobileMenu.scss';
import {ReactComponent as Logo} from "../../img/SVG/Vieunite_logo_Text-black-01.svg";
import {Divider} from "antd";
import {useNavigate} from "react-router-dom";

export default function MobileMenu() {
    return (
        <>
            <h1>
                <a href="/home"><Logo/></a>
            </h1>

            <input id="burger" type="checkbox"/>

            <label htmlFor="burger">
                <span></span>
                <span></span>
                <span></span>
            </label>

            <nav>
                <ul>
                    <li><a href="/digital-canvas">Textura</a><Divider className={'m-menu-divider'}/></li>
                    <li><a href="/artists">Vieunite Artists</a><Divider className={'m-menu-divider'}/></li>
                    <li><a href="/news">News</a><Divider className={'m-menu-divider'}/></li>
                    <li><a href="/contact">Contact Us</a><Divider className={'m-menu-divider'}/></li>
                    <li onClick={() => {
                        if ((/Android/i.test(navigator.userAgent))) {
                            window.location.href = 'https://play.google.com/store/apps/details?id=com.app.vieunite&gl=GB';
                        }
                        if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
                            window.location.href = 'https://apps.apple.com/gb/app/vieunite/id1644381065';
                        }
                    }}><a>Vieunite App</a><Divider className={'m-menu-divider'}/></li>
                    {/*<li>*/}
                    {/*    <a href={'/artistportal'}>Artist Portal</a>*/}
                    {/*</li>*/}
                    <li><a href="/artistportal">Artist Portal</a><Divider className={'m-menu-divider'}/></li>
                </ul>
            </nav>
        </>
    )
}